import { alpha } from '@mui/material/styles';

export const REPORT_HEADER_BLUE = '#0D2240';
export const REPORT_HEADER_ACCENT = '#4A7C59';
export const REPORT_PRINT_BANNER = '#FFFFFF';
export const REPORT_PRINT_BANNER_TEXT = '#111111';

function normalizeColor(value, fallback) {
  if (value == null) return fallback;
  const s = String(value).trim();
  return s !== '' ? s : fallback;
}

/** Keep printed reports on white paper regardless of on-screen dark header. */
export const REPORT_PRINT_KEEP_CSS = `
        [data-pdf-keep],
        tr {
          break-inside: avoid !important;
          page-break-inside: avoid !important;
        }
`;

export const reportKeepTogetherSx = {
  breakInside: 'avoid',
  pageBreakInside: 'avoid',
  '@media print': {
    breakInside: 'avoid',
    pageBreakInside: 'avoid',
  },
};

export const reportHeaderPrintSx = {
  bgcolor: `${REPORT_PRINT_BANNER} !important`,
  color: `${REPORT_PRINT_BANNER_TEXT} !important`,
  WebkitPrintColorAdjust: 'exact',
  printColorAdjust: 'exact',
};

export function getReportFormPalette(isDark, tenantBranding = null) {
  const tenantSecondary = normalizeColor(tenantBranding?.secondaryColor, '');
  const accent = tenantSecondary || (isDark ? '#6BA87A' : REPORT_HEADER_ACCENT);

  if (isDark) {
    return {
      border: `1px solid ${alpha('#E8EEF7', 0.28)}`,
      surface: '#1B2433',
      text: '#E8EEF7',
      muted: alpha('#E8EEF7', 0.72),
      headBg: alpha('#E8EEF7', 0.08),
      tableHead: alpha('#E8EEF7', 0.08),
      banner: REPORT_HEADER_BLUE,
      accent,
      bannerText: '#F4F7FB',
      logoBg: '#FFFFFF',
      checkbox: '#A8C5FF',
    };
  }

  return {
    border: '1px solid #1a1a1a',
    surface: '#fff',
    text: '#111',
    muted: '#333',
    headBg: '#f5f5f5',
    tableHead: '#f4f6f8',
    banner: REPORT_PRINT_BANNER,
    accent,
    bannerText: REPORT_PRINT_BANNER_TEXT,
    logoBg: '#fff',
    checkbox: undefined,
  };
}
